import { db, type OutboxItem } from './idb';

export type { OutboxItem } from './idb';

export async function enqueue(item: OutboxItem): Promise<void> {
  await (await db()).put('outbox', item);
  notify();
}

export async function listOutbox(): Promise<OutboxItem[]> {
  const all = await (await db()).getAll('outbox');
  return all.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
}

export async function getOutbox(id: string): Promise<OutboxItem | undefined> {
  return (await db()).get('outbox', id);
}

export async function updateOutbox(id: string, patch: Partial<OutboxItem>): Promise<void> {
  const d = await db();
  const cur = await d.get('outbox', id);
  if (!cur) return;
  await d.put('outbox', { ...cur, ...patch });
  notify();
}

export async function removeOutbox(id: string): Promise<void> {
  await (await db()).delete('outbox', id);
  notify();
}

export async function pendingCount(): Promise<number> {
  const all = await listOutbox();
  return all.filter((i) => i.status === 'pending' || i.status === 'syncing').length;
}

// ---- lightweight change notifier so the UI badge updates ----
const listeners = new Set<() => void>();
export function onOutboxChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
function notify() {
  listeners.forEach((f) => f());
}
